import type { ReactNode } from 'react'
import { Reveal } from './Reveal'

export function SectionHead({ eyebrow, title, children }: { eyebrow: string; title: ReactNode; children: ReactNode }) {
  return (
    <Reveal className="head">
      <div>
        <div className="eyebrow">{eyebrow}</div>
        <h2>{title}</h2>
      </div>
      <p>{children}</p>
    </Reveal>
  )
}
